<div class="min-h-screen bg-[rgb(var(--pt-bg))] text-slate-100">
  @if (mobileMenuOpen()) {
    <div class="relative z-50 lg:hidden" role="dialog" aria-modal="true" (click)="closeMobileMenu()">
      <div class="fixed inset-0 bg-black/60 backdrop-blur-sm"></div>

      <div class="fixed inset-0 flex" (click)="$event.stopPropagation()">
        <div class="relative mr-16 flex w-full max-w-xs flex-1">
          <div class="absolute left-full top-0 flex w-16 justify-center pt-5">
            <button
              type="button"
              class="inline-flex h-10 w-10 items-center justify-center rounded-full bg-white/5 text-slate-100 ring-1 ring-white/10 hover:bg-white/10"
              (click)="closeMobileMenu()"
              aria-label="Menü schließen"
            >
              <svg class="h-5 w-5 block" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M6 18L18 6M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
              </svg>
            </button>
          </div>

          <div class="flex grow flex-col gap-y-6 overflow-y-auto bg-[rgb(var(--pt-sidebar))] px-5 pb-5 ring-1 ring-white/10">
            <div class="flex h-14 items-center gap-x-3">
              <img
                src="/pulsetrader.png"
                alt="PulseTrader"
                class="h-9 w-9 rounded-xl object-cover ring-1 ring-white/10"
              />
              <span class="text-sm font-semibold tracking-wide">PulseTrader</span>
            </div>

            <nav class="flex flex-1 flex-col">
              <ul role="list" class="flex flex-1 flex-col gap-y-1">
                @for (item of navItems(); track item.key) {
                  <li>
                    <a
                      [routerLink]="item.path"
                      routerLinkActive="bg-[rgb(var(--pt-sidebar-hover))] text-slate-50 [&>svg]:text-slate-200"
                      [routerLinkActiveOptions]="{ exact: true }"
                      class="group relative flex items-center gap-x-3 rounded-lg px-3 py-2 text-sm font-semibold text-slate-200/80 hover:bg-[rgb(var(--pt-sidebar-hover))] hover:text-slate-50"
                      (click)="closeMobileMenu()"
                    >
                      <span class="absolute left-0 top-0 bottom-0 w-1 rounded-r bg-white/60 opacity-0 transition-opacity group-hover:opacity-30"></span>

                      <svg class="h-5 w-5 block shrink-0 text-slate-400" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                        @for (d of iconPath(item.icon); track d) {
                          <path
                            [attr.d]="d"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        }
                      </svg>

                      <span class="truncate">{{ item.label }}</span>
                    </a>
                  </li>
                }
              </ul>
            </nav>
          </div>
        </div>

        <div class="w-16"></div>
      </div>
    </div>
  }

  <div class="hidden lg:fixed lg:inset-y-0 lg:z-40 lg:flex lg:w-72 lg:flex-col">
    <div class="flex grow flex-col gap-y-6 overflow-y-auto bg-[rgb(var(--pt-sidebar))] px-6 pb-6 ring-1 ring-white/10">
      <div class="flex h-16 items-center gap-x-3">
        <img
          src="/pulsetrader.png"
          alt="PulseTrader"
          class="h-9 w-9 rounded-xl object-cover ring-1 ring-white/10"
        />
        <span class="text-sm font-semibold tracking-wide">PulseTrader</span>
      </div>

      <nav class="flex flex-1 flex-col">
        <ul role="list" class="flex flex-1 flex-col gap-y-1">
          @for (item of navItems(); track item.key) {
            <li>
              <a
                [routerLink]="item.path"
                #rla="routerLinkActive"
                routerLinkActive="bg-[rgb(var(--pt-sidebar-hover))] text-slate-50 [&>svg]:text-slate-200"
                [routerLinkActiveOptions]="{ exact: true }"
                class="group relative flex items-center gap-x-3 rounded-lg px-3 py-2 text-sm font-semibold text-slate-200/80 hover:bg-[rgb(var(--pt-sidebar-hover))] hover:text-slate-50"
              >
                <span class="absolute left-0 top-0 bottom-0 w-1 rounded-r bg-white/60 opacity-0 transition-opacity group-hover:opacity-30"></span>

                @if (rla.isActive) {
                  <span class="absolute left-0 top-0 bottom-0 w-1 rounded-r bg-white"></span>
                }

                <svg class="h-5 w-5 block shrink-0 text-slate-400" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  @for (d of iconPath(item.icon); track d) {
                    <path
                      [attr.d]="d"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  }
                </svg>

                <span class="truncate">{{ item.label }}</span>
              </a>
            </li>
          }
        </ul>
      </nav>
    </div>
  </div>

  <div class="lg:pl-72">
    <header class="sticky top-0 z-30 border-b border-white/10 bg-[rgb(var(--pt-bg))]/90 backdrop-blur">
      <div class="flex h-16 items-center gap-x-4 px-4 sm:px-6 lg:px-8">
        <button
          type="button"
          class="inline-flex h-10 w-10 items-center justify-center rounded-full bg-white/5 text-slate-100 ring-1 ring-white/10 hover:bg-white/10 lg:hidden"
          (click)="openMobileMenu()"
          aria-label="Menü öffnen"
        >
          <svg class="h-5 w-5 block" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M4 6h16M4 12h16M4 18h16" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
          </svg>
        </button>

        <div class="flex-1"></div>

        <button
          type="button"
          class="inline-flex h-10 w-10 items-center justify-center rounded-full bg-white/5 text-slate-100 ring-1 ring-white/10 hover:bg-white/10 focus:outline-none focus:ring-2 focus:ring-[rgb(var(--pt-ring))]"
          (click)="toggleTheme($event)"
          aria-label="Theme umschalten"
        >
          @if (isDark()) {
            <svg class="h-5 w-5 block" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path
                d="M21 13.5A8.5 8.5 0 0 1 10.5 3a6.5 6.5 0 1 0 10.5 10.5Z"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          } @else {
            <svg class="h-5 w-5 block" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path
                d="M12 3v2M12 19v2M4.22 5.22l1.42 1.42M18.36 18.36l1.42 1.42M3 12h2M19 12h2M4.22 18.78l1.42-1.42M18.36 5.64l1.42-1.42"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
              />
              <path d="M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z" stroke="currentColor" stroke-width="2" />
            </svg>
          }
        </button>

        <div class="relative" (click)="toggleUserMenu($event)">
          <button
            type="button"
            class="inline-flex items-center gap-x-2 rounded-full bg-white/5 px-2 py-1 ring-1 ring-white/10 hover:bg-white/10"
            aria-label="Benutzermenü öffnen"
          >
            <span class="inline-flex h-9 w-9 items-center justify-center rounded-full bg-white/10 text-xs font-semibold ring-1 ring-white/10">
              {{ userInitial() }}
            </span>
            <span class="hidden text-sm font-semibold text-slate-100 sm:block">{{ displayName() }}</span>
            <svg class="h-4 w-4 block text-slate-300" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path
                fill-rule="evenodd"
                d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.17l3.71-3.94a.75.75 0 1 1 1.08 1.04l-4.25 4.5a.75.75 0 0 1-1.08 0l-4.25-4.5a.75.75 0 0 1 .02-1.06Z"
                clip-rule="evenodd"
              />
            </svg>
          </button>

          @if (userMenuOpen()) {
            <div
              class="absolute right-0 mt-2 w-56 overflow-hidden rounded-2xl bg-[rgb(var(--pt-surface))] shadow-lg ring-1 ring-white/10"
              (click)="closeUserMenu($event)"
            >
              <div class="px-4 py-3">
                <div class="text-sm font-semibold text-slate-100">{{ displayName() }}</div>
                <div class="text-xs text-slate-400">Signed in</div>
              </div>
              <div class="h-px bg-white/10"></div>

              <div class="py-1">
                <button
                  type="button"
                  class="w-full px-4 py-2 text-left text-sm text-slate-200 hover:bg-white/5"
                  [routerLink]="['/profile']"
                  (click)="closeUserMenu()"
                >
                  Mein Profil
                </button>
                <button type="button" class="w-full px-4 py-2 text-left text-sm text-slate-200 hover:bg-white/5">Einstellungen</button>
              </div>

              <div class="h-px bg-white/10"></div>

              <div class="py-1">
                <button type="button" class="w-full px-4 py-2 text-left text-sm text-slate-200 hover:bg-white/5">Privacy policy</button>
                <button type="button" class="w-full px-4 py-2 text-left text-sm text-slate-200 hover:bg-white/5">Help Center</button>
              </div>

              <div class="h-px bg-white/10"></div>

              <div class="py-1">
                <button type="button" class="w-full px-4 py-2 text-left text-sm text-slate-200 hover:bg-white/5" (click)="signOut($event)">
                  Sign out
                </button>
              </div>
            </div>
          }
        </div>
      </div>
    </header>

    <main class="px-4 py-8 sm:px-6 lg:px-8">
      <router-outlet />
    </main>
  </div>
</div>
